import React, { useRef, useState } from "react";
import Nav from "../layouts/Nav";
import Hero from "../layouts/Hero";
import Skillset from "../layouts/Skillset";
import Project from "../layouts/Project";
import Contact from "../layouts/Contact";
import Footer from "../layouts/Footer";
import ProjectDetail from "../layouts/ProjectDetail";
import { project } from "../assets/data.json";

export default function LandingPage() {
  const refMessage = useRef();
  const refSkillset = useRef();
  const refProject = useRef();

  //Handle project modal & get project id
  const [isOpen, setisOpen] = useState(false);
  const [projectId, setprojectId] = useState("");
  const handleModal = () => {
    setisOpen(!isOpen);
  };
  const handleProjectId = (id) => {
    setprojectId(id);
  };

  let projectClassName;
  if (isOpen) {
    projectClassName = "block";
  } else {
    projectClassName = "hidden";
  }

  return (
    <div>
      <ProjectDetail
        project={project}
        className={projectClassName}
        closeProjectModal={handleModal}
        isOpen={isOpen}
        projectId={projectId}
      />
      <header className="py-8 container mx-auto px-3 md:pt-2">
        <Nav refSkillset={refSkillset} refProject={refProject} />
        <Hero refMessage={refMessage} />
      </header>
      <main className="py-16 text-center">
        <Skillset ref={refSkillset} />
        <Project
          project={project}
          ref={refProject}
          openProjectModal={handleModal}
          getProjectId={handleProjectId}
        />
        <Contact ref={refMessage} />
      </main>
      <Footer />
    </div>
  );
}
